class MiniCart extends HTMLElement {
  constructor() {
    super();
    this._contentRendered = false;
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');

    // drawer-close-button fires 'drawer:force-close' bubbling up the DOM.
    // Since mini-cart is now outside cart-drawer, the event never reaches it.
    // Catch it here and forward it to cart-drawer directly.
    this.addEventListener('drawer:force-close', (e) => {
      e.stopPropagation();
      if (this.drawer) this.drawer.dispatchEvent(new CustomEvent('drawer:force-close', { bubbles: true, cancelable: true }));
    });

    // Eagerly fetch the initial cart content.
    // IntersectionObserver is not used here because the element is
    // position:fixed;transform:translateX(100%) — always off-screen,
    // so the observer would never fire.
    fetch(this.dataset.url)
      .then(r => r.text())
      .then(html => {
        if (this._contentRendered) return; // renderContents already ran, don't overwrite
        const content = this.getSectionInnerHTML(html, '.shopify-section');
        if (content) this.innerHTML = content;
      })
      .catch(e => console.error(e));
  }

  open() {
    if (!this.drawer) return;
    const detailsElement = this.drawer.querySelector('details');
    if (!detailsElement || detailsElement.hasAttribute('open')) {
      return;
    }
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this._contentRendered = true;
    this.productId = parsedState.id;

    // Update mini-cart drawer content
    const miniCartEl = document.getElementById('mini-cart');
    if (miniCartEl && parsedState.sections && parsedState.sections['mini-cart']) {
      const newContent = this.getSectionInnerHTML(
        parsedState.sections['mini-cart'], '.shopify-section'
      );
      if (newContent) miniCartEl.innerHTML = newContent;
    }

    // Update all cart count bubbles via /cart.js.
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const count = cart.item_count || 0;
        ['cart-icon-bubble', 'cart-icon-bubble-mobile', 'mobile-cart-icon-bubble'].forEach(id => {
          const el = document.getElementById(id);
          if (!el) return;
          let bubble = el.querySelector('.cart-count-bubble');
          if (count > 0) {
            if (!bubble) {
              bubble = document.createElement('span');
              el.appendChild(bubble);
            }
            bubble.className = 'cart-count-bubble' + (count >= 100 ? ' cart-count-bubble--dot' : '');
            bubble.innerHTML = count < 100
              ? `<span aria-hidden="true">${count}</span><span class="visually-hidden">${count} items</span>`
              : `<span class="visually-hidden">${count} items</span>`;
          } else {
            if (bubble) bubble.remove();
          }
        });
      })
      .catch(e => console.error('bubble update error:', e));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return '';
    const el = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
    return el ? el.innerHTML : '';
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);
